var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f7f5ee !important","padding-left":"10px","padding-right":"10px","height":"100vh"}},[_c('h1',{staticStyle:{"text-align":"center","padding-top":"100px","margin":"0px","border":"0"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }